import React, { useState, useEffect } from 'react';
import Image from '../../../components/atom/image/index';
import './shared.css';
import { useHistory } from "react-router-dom";
import Api from "../../../services/loginApi"
import Cookie from '../../../lib/cookie';
import { useDispatch, useSelector } from 'react-redux';

let api = new Api()

const Navbar = (props) => {
  let cookie = new Cookie();
  let dispatch = useDispatch();
  const history = useHistory();
  const [navType, setNavType] = useState('');
  const stateData = useSelector(state => state.Auth)


  const handleLogout = () => {
    cookie.removeCookie('sidekey');
    localStorage.removeItem('etfscheme');
    localStorage.removeItem('etfslient');
    cookie.removeCookie('etftoken');
    api.logout();
    window.location.href = '/etf/transact/login'
  }

  useEffect(() => {
    let getNavbar = document.querySelectorAll('.navbarTop .nav-item');
    getNavbar.forEach((el) => {
      el.addEventListener('mouseover', function (curr) {
        console.log(el.childNodes, 'el.childNodes', curr)
        if (el.childNodes[1] !== undefined) {
          el.childNodes[1].classList.add('show');
          el.classList.add('show');
        }

      });
      el.addEventListener('mouseout', function (curr) {
        console.log(el.childNodes, 'el.childNodesover', curr)
        if (el.childNodes[1] !== undefined) {
          el.childNodes[1].classList.remove('show');
          el.classList.remove('show');
        }

      });
    })
  }, [])

  const gotoResetPasscode = () => {
    cookie.removeCookie('sidekey');
    localStorage.removeItem('etfscheme');
    localStorage.removeItem('etfslient');
    cookie.removeCookie('etftoken');
    api.logout();
    let page_url = process.env.REACT_APP_MODE === "development" ? "/etf/transact/login/resetpasscode" : "/etf/transact/login/resetpasscode";
    window.location.href = page_url;

  }

  const toggleOffcanvas = () => {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
    // document.querySelector('button.navbar-toggler.navbar-toggler-right').classList.toggle('open');

  }

  let customerName = "";
  // if (getArn !== "") {

  //   customerName = getArn.clientName

  // }
  let panDetails = localStorage.getItem('uniqueKey');
  panDetails = JSON.parse(panDetails)

  if (panDetails && panDetails.nameAsOnPan) {
    customerName = panDetails.nameAsOnPan;
  } else if (stateData['cvlData'] !== null) {
    customerName = stateData['cvlData']['nameAsOnPan'];
  }


  return (
    <React.Fragment>
      <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">



        <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
          <a className="navbar-brand brand-logo" href="#">
            {/* <img src="assets/images/logo.svg" alt="logo" /> */}
            {/* <Image image="nav/mf-amc-brst-logo.png" alt="logo" /> */}
            <Image image="nav/moamc-mf-logo-new.png" alt="logo" />
          </a>
          <a className="navbar-brand brand-logo-mini" href="#">
            {/* <Image image="nav/mf-m-min-logo.svg" alt="logo" /> */}
            <Image image="nav/mf-m-min-logo.svg" alt="logo" />
            {/* <img src="assets/images/logo-mini.svg" alt="logo" /> */}
          </a>
        </div>
        <div className="navbar-menu-wrapper d-flex align-items-stretch">
          <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize" onClick={() => document.body.classList.toggle('sidebar-icon-only')}>
            <span className="mdi mdi-menu"></span>
          </button>

          <ul className="navbar-nav navbar-nav-right navbarTop">

            <li className="nav-item nav-profile dropdown mobile_hover" >
              <a className="nav-link dropdown-toggle" id="profileDropdown" href="#" data-toggle="dropdown" aria-expanded="false">
                <div className="nav-profile-img">
                  {/* <Image image="nav/profile-icon.png" class="mobileProfile" alt="image" /> */}
                  <Image image="nav/profile-icon.png" class="mobileProfile" alt="image" />
                </div>
                <div className="nav-profile-text">
                  <p className="mb-1 text-black">{customerName && customerName}</p>
                </div>
              </a>

              <div className="dropdown-menu navbar-dropdown mobile_open dropdown-menu-right p-0 border-0 font-size-sm" aria-labelledby="profileDropdown" id="myDIV" data-x-placement="bottom-end">

                <div className="p-2">
                  {/* <h5 onClick={closePOpUp} className="dropdown-header text-uppercase pl-2 text-dark">User Options</h5> */}

                  {/* <a className="dropdown-item py-1 d-flex align-items-center justify-content-between" onClick={gotoContactUs}>
                  <span>Contact Us</span>
                  <span className="p-0">
                  </span>
                </a> */}
                  {/* <a onClick={closePOpUp} className="dropdown-item py-1 d-flex align-items-center justify-content-between" href="/aif/profile">
                  <span>Profile</span>
                  <span className="p-0">
                    <i className="mdi mdi-account-outline ml-1"></i>
                  </span>
                </a> */}

                  <div role="separator" className="dropdown-divider"></div>
                  <h5 className="dropdown-header text-uppercase  pl-2 text-dark mt-2">Actions</h5>

                  <a onClick={gotoResetPasscode}
                    className="dropdown-item py-1 d-flex align-items-center justify-content-between"
                  >
                    <span>Reset Passcode</span>
                    <span className="p-0">
                      <i className="mdi mdi-lock-reset ml-1"></i>
                    </span>
                  </a>

                  <a className="dropdown-item py-1 d-flex align-items-center justify-content-between" onClick={handleLogout}>
                    <span>Log Out</span>
                    <i className="mdi mdi-logout ml-1"></i>
                  </a>
                </div>
              </div>
            </li>

          </ul>
          <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas" onClick={() => toggleOffcanvas()} id="mobileBAR">
            <span className="mdi mdi-menu"></span>
          </button>
        </div>
      </nav>
    </React.Fragment>
  )
}

export default Navbar